import TermsAndConditionsGate from './TermsAndConditionsGate'
export default TermsAndConditionsGate
